import React from 'react';
import { Overlay, Container, FormTextInput } from 'routes/auth/style';
import { H2 } from 'components/typography';
import Form from 'components/form';
import { WithMargin } from 'components/layout';
import { useTranslation } from 'i18n';
import { useUserApi } from 'services/user-service';
import { useHistory } from 'react-router-dom';
import { useLocalState } from 'state';
import { object, string } from 'yup';
import storage from 'services/storage';
import { toast } from 'services/toast';
import { typography } from 'styles/settings';
import { useLocation } from 'react-router';

function createValidationSchema(t) {
  return function () {
    return object().shape({
      email: string().required(t('Email is required.')),
      password: string()
        .required(t('No password provided'))
        .min(5, t('Password is too short - should be 5 chars minimum.')),
    });
  };
}

export default function AdminLogin() {
  const { t } = useTranslation();
  const location = useLocation();
  const { setToState } = useLocalState();
  const userApi = useUserApi();
  const history = useHistory();

  const email = new URLSearchParams(location.search).get('email');

  async function onSubmit({ email, password }) {
    const response = await userApi.adminLogin(email, password);

    if (response.isSuccess) {
      const adminToken = response.getField('data.token');
      const user = response.getField('data.user');

      await setToState({ user });

      await storage.setAdminToken(adminToken);

      return history.push('/admin-new/');
    }

    toast.error(response.getErrorMessage());
  }

  const initialValues = {
    email: email || '',
    password: '',
  };

  const validationSchema = createValidationSchema(t);

  return (
    <Overlay>
      <Container>
        <WithMargin bottom={typography.size.xl}>
          <H2>{t('Admin Login')}</H2>
        </WithMargin>
        <Form
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          submitOnEnter>
          {(form) => (
            <>
              <FormTextInput name="email" placeholder={t('E-Mail')} />
              <FormTextInput
                type="password"
                name="password"
                placeholder={t('Password')}
              />

              <WithMargin bottom={typography.size.md}>
                <Form.SubmitButton
                  label={t('Login')}
                  onClick={form.handleSubmit}
                  loading
                />
              </WithMargin>

              <Form.Button
                label={t('Not registered?')}
                onClick={() => history.push('/register')}
                link
              />

              <Form.Button
                label={t('Forgot password?')}
                onClick={() => history.push('/forgot-password')}
                link
              />
            </>
          )}
        </Form>
      </Container>
    </Overlay>
  );
}
